module.exports = __webpack_public_path__ + "static/img/Logo_white.6e20279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_white.png
// module id = 96uY
// module chunks = 1